import React from 'react';
import { Card, CardContent, Collapse, CardHeader, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { faAngleDown, faAngleUp } from '@fortawesome/pro-solid-svg-icons';
import clsx from 'clsx';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const StyledCard = styled(Card)({
    overflow: 'visible',
});

const StyledCardHeader = styled(CardHeader)({
    borderBottom: '1px solid #e6edf5',
    fontSize: 16,
    padding: '10px',
    width: '100%',
    display: 'inline-flex',
    fontWeight: 700,
});

class CollapsableCard extends React.Component {
    render() {
        let { title, children, avatar = null, expanded, handleCollapse = () => { } } = this.props;
        return (
            <StyledCard>
                <StyledCardHeader
                    disableTypography
                    title={title}
                    action={
                        <IconButton onClick={() => handleCollapse()} size="large">
                            <FontAwesomeIcon icon={expanded ? faAngleUp : faAngleDown} />
                        </IconButton>
                    }
                    avatar={avatar}
                />
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <CardContent>
                        {children}
                    </CardContent>
                </Collapse>
            </StyledCard>
        );
    }
}

export default CollapsableCard;
